export const SIDEBAR_DIMENSIONS = {
  // Main Sidebar
  MAIN_EXPANDED_PX: 256,
  MAIN_COLLAPSED_PX: 72,
  MAIN_EXPANDED_WIDTH: '256px',
  MAIN_COLLAPSED_WIDTH: '72px',
  // Extended/Settings Sidebar
  EXTENDED_WIDTH_PX: 256,
  EXTENDED_WIDTH: '256px',
  // Top Bar
  TOP_BAR_HEIGHT_PX: 64,
  TOP_BAR_HEIGHT: '64px',
  // Logo Section
  LOGO_SECTION_HEIGHT_PX: 64,
  LOGO_SECTION_HEIGHT: '64px',
  LOGO_COLLAPSED_WIDTH: '30px',
  LOGO_EXPANDED_WIDTH: '198px',
  LOGO_COLLAPSED_MARGIN_LEFT: '8px',
} as const;

export const ANIMATION_DURATION = 300;

/**
 * CSS filter to convert icon to active state color (#0046a0).
 * Uses brightness, saturation, invert, sepia, hue-rotate, and contrast filters
 * to transform the icon to the brand blue color.
 */
export const ACTIVE_ICON_FILTER =
  'brightness(0) saturate(100%) invert(13%) sepia(94%) saturate(3844%) hue-rotate(210deg) brightness(95%) contrast(101%)';

/**
 * CSS filter for inactive icon state (#1f1f1f color).
 */
export const INACTIVE_ICON_FILTER =
  'brightness(0) saturate(100%) invert(10%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)';

/**
 * CSS filter for highlight variant icons (blue color #0046a0).
 * Uses brightness, saturation, invert, sepia, hue-rotate, and contrast filters
 * to transform the icon to the brand blue color.
 */
export const HIGHLIGHT_ICON_FILTER =
  'invert(33%) sepia(98%) saturate(1500%) hue-rotate(199deg) brightness(93%) contrast(101%)';

/**
 * Z-index values for layering UI components.
 *
 * Z-index hierarchy:
 * - z-15: Dropdown menus in topbar (below topbar, above content)
 * - z-20: Topbar, extended sidebar
 * - z-30: Main sidebar
 * - z-50: Tooltips, dialogs, modals, overlays
 * - z-10000: Copilot drawer (above all layout components)
 */
export const Z_INDEX = {
  DROPDOWN_MENU: 15, // Below topbar (z-20), above content
  TOPBAR: 20,
  SIDEBAR_EXTENDED: 20,
  SIDEBAR_MAIN: 30,
  TOOLTIP: 50,
  DIALOG: 50,
  MODAL: 50,
  OVERLAY: 50,
  COPILOT_DRAWER: 10000, // Above all layout components (layout container is z-1000)
} as const;

/**
 * 2026 HG brand. The topbar's chrome (bottom rule, logo divider, switcher,
 * avatar) is prussian.
 */
export const BRAND_COLORS = {
  PRUSSIAN: '#071834',
} as const;
